<!-- 车辆审批记录页面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="section-mian_right">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <!-- 表格按钮 自定义 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <template slot="fileCode" slot-scope="scope">
              <img
                :src="getImgPath(scope.row.fileCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 25px; width: 50px"
                @click="showViewer(getImgPath(scope.row.fileCode), $event)"
              />
            </template>
            <template slot="status" slot-scope="scope">
              <span
                v-if="scope.row.status === '1'"
                style="color: yellow; cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.status | statusFilter }}</span
              >
              <span
                v-else-if="scope.row.status === '2'"
                style="color: #00e8bb; cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.status | statusFilter }}</span
              >
              <span
                v-else-if="scope.row.status === '3'"
                style="color: red; cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.status | statusFilter }}</span
              >
              <span
                v-else
                style="cursor: pointer"
                @click="handleView(scope.row, scope.index)"
                >{{ scope.row.status | statusFilter }}</span
              >
            </template>
          </ioc-table>
          <detail-dialog
            ref="detailDialog"
            :detailData="detailData"
            :workFlowDetail="workFlowData"
          ></detail-dialog>
          <viewer
            @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer"
          >
            <img v-for="src in viewerPhotos" :src="src" :key="src" />
          </viewer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api/index";
import { Dic, Bus, Dates } from "$utils";
import utils from "$utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../config/table";
import detailDialog from "../components/detailDialog";
export default {
  components: {
    detailDialog,
  },
  filters: {
    statusFilter(val) {
      return Dic.findByValue("SENU080009", val);
    },
  },
  data() {
    return {
      viewerPhotos: [],
      viewerInstance: null,
      tableOption: tableOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      // 员工用户组列表查询参数
      searchParams: {},
      areaDevGroupValue: [],
      areaDevGroup: [],
      detailData: {},
      workFlowData: [],
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    // 获取列表
    getList() {
      const params = {};
      params.plateCode = this.searchParams.plateCode;
      params.name = this.searchParams.name;
      params.phone = this.searchParams.phone;
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.car.getRecordList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },

    handleView(row, index) {
      let params = {
        appointmentCode: row.appointmentCode,
      };
      this.$fetch(api.car.getDetails, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.detailData = response.returnObj;
      });
      this.$fetch(api.car.getWorkFlow, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.workFlowData = response.returnObj;
      });
      this.$nextTick(() => {
        this.$refs.detailDialog.open();
      });
    },

    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      this.searchParams = Object.assign(param);
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.access-record-container {
  width: 100%;
  height: 100%;
  .el-table__fixed-right-patch {
    display: none;
  }
  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}
</style>
